import { render, staticRenderFns } from "./createPVCenterAlloc.vue?vue&type=template&id=0d815bf0&"
import script from "./createPVCenterAlloc.vue?vue&type=script&lang=js&"
export * from "./createPVCenterAlloc.vue?vue&type=script&lang=js&"
import style0 from "./createPVCenterAlloc.vue?vue&type=style&index=0&id=0d815bf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports